import React, {
	useCallback,
	useEffect,
	useRef,
	useState,
} from 'react'
import FormatBoldIcon from '@mui/icons-material/FormatBold'
import FormatItalicIcon from '@mui/icons-material/FormatItalic'
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined'

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { mergeRegister } from '@lexical/utils'
import {
	$getSelection,
	$isRangeSelection,
	COMMAND_PRIORITY_LOW,
	FORMAT_TEXT_COMMAND,
	SELECTION_CHANGE_COMMAND,
} from 'lexical'
import { useIntl } from 'react-intl'

export default function ToolbarPlugin() {
	const [editor] = useLexicalComposerContext()
	const { formatMessage } = useIntl()

	const toolbarRef = useRef(null)
	const [isBold, setIsBold] = useState(false)
	const [isItalic, setIsItalic] = useState(false)
	const [isUnderline, setIsUnderline] = useState(false)
	const $updateToolbar = useCallback(() => {
		const selection = $getSelection()
		if ($isRangeSelection(selection)) {
			setIsBold(selection.hasFormat('bold'))
			setIsItalic(selection.hasFormat('italic'))
			setIsUnderline(selection.hasFormat('underline'))
		}
	}, [])

	useEffect(() => {
		return mergeRegister(
			editor.registerUpdateListener(({ editorState }) => {
				editorState.read(
					() => {
						$updateToolbar()
					},
					{ editor }
				)
			}),
			editor.registerCommand(
				SELECTION_CHANGE_COMMAND,
				() => {
					$updateToolbar()
					return false
				},
				COMMAND_PRIORITY_LOW
			)
		)
	}, [editor, $updateToolbar])

	return (
		<div className="text-sm" ref={toolbarRef}>
			<button
				type="button"
				onClick={() => {
					editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold')
				}}
				className={`border h-8 text-lg leading-none py-1 px-2 ${isBold ? 'bg-[#d8d8d8]' : ''}`}
				aria-label={formatMessage({
					id: 'rich_text_editor.toolbar.bold',
				})}
			>
				<FormatBoldIcon fontSize="inherit" />
			</button>
			<button
				type="button"
				onClick={() => {
					editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'italic')
				}}
				className={`border h-8 text-lg leading-none py-1 px-2 ${isItalic ? 'bg-[#d8d8d8]' : ''}`}
				aria-label={formatMessage({
					id: 'rich_text_editor.toolbar.italic',
				})}
			>
				<FormatItalicIcon fontSize="inherit" />
			</button>
			<button
				type="button"
				onClick={() => {
					editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'underline')
				}}
				className={`border h-8 text-lg leading-none py-1 px-2 ${isUnderline ? 'bg-[#d8d8d8]' : ''}`}
				aria-label={formatMessage({
					id: 'rich_text_editor.toolbar.underline',
				})}
			>
				<FormatUnderlinedIcon fontSize="inherit" />
			</button>
		</div>
	)
}
